
import $api from '../../services/axios';
import router from '../../router/index';

export const AUTH = 'AUTH';
export const TRACK_VISA = 'TRACK_VISA';
export const LINEAR_LOADER = 'LINEAR_LOADER';
export const APPLICANT_DETAIL = 'APPLICANT_DETAIL';
export const AUTH_USER = 'AUTH_USER';
export const NAVBAR = 'NAVBAR';

const state = {
    isLoggedIn: false,
    visa: {},
    detail: {},
    authUser: {},
    loader: false,
    toggle: true,
};

const mutations = {
    [AUTH](state, payload){
        state.isLoggedIn = payload;
    },
    [TRACK_VISA](state, payload){
        state.visa = payload;
    },
    [APPLICANT_DETAIL](state, payload){
        state.detail = payload;
    },
    [AUTH_USER](state, payload){
        state.authUser = payload;
    },
    [LINEAR_LOADER](state, payload){
        state.loader = payload;
    },
    [NAVBAR](state, payload){
        state.toggle = payload;
    }
};

const actions = {
    async registerApplicant(context, formData){
         let applicant = await $api.post(`/students/register`, formData);
         let token = applicant.data.jwt_token;
         localStorage.setItem('token',token);
         localStorage.setItem('applicant', JSON.stringify(applicant.data))
         await context.commit(AUTH, true);
         await context.commit(AUTH_USER, applicant.data);
         router.push('/')
    },
    async loginApplicant(context,loginData){
        let applicant = await $api.post(`/students/login`, loginData)
        let token = applicant.data.jwt_token;
         localStorage.setItem('token',token);
         localStorage.setItem('applicant', JSON.stringify(applicant.data))
         await context.commit(AUTH, true);
         await context.commit(AUTH_USER, applicant.data);
         router.push('/')
    },
    async trackVisa(context,formData){
        let url = `status-code`;
        let res = await $api.getWithPayload(url, formData);
        await context.commit('TRACK_VISA',res);
        return res;
    },
    async applicantProfile(context, formData){
        let url = `students/detail`;
        let res = await $api.post(url, formData);
        await context.dispatch('applicantDetail', formData.student_id)
        return res.data;
    },
    async applicantDetail(context, studentId){
        let url = `students/detail/${studentId}`;
        let res = await $api.get(url);
        await context.commit(APPLICANT_DETAIL,res);
    }


};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
    isLoggedIn: state => state.isLoggedIn,
    visa: state => state.visa,
    profile: state => state.profile,
    detail: state => state.detail,
    authUser: state => state.authUser,
    loader: state => state.loader,
    toggle: state => state.toggle,
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/applicant.js